import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'

export interface ISystemConfig {
  currentDeviceType: number
  globalData: any
  systemData: any
  loginData: any
}

@Module({ dynamic: true, store, name: 'store_systemconfig' })
class SystemConfig extends VuexModule implements ISystemConfig {
  public currentDeviceType = 0;
  public globalData: any = {};
  public systemData: any = {};
  public loginData: any = {};

  @Mutation
  public setCurrentDeviceType(num) {
    this.currentDeviceType = num;
  }

  @Mutation
  public setGlobalData(num) {
    this.globalData = num;
  }

  @Mutation
  public setSystemData(num) {
    this.systemData = num;
  }

  @Mutation
  public setLoginData(num) {
    this.loginData = num;
  }
}

export const SystemConfigModule = getModule(SystemConfig)
